module.exports = __webpack_public_path__ + "static/media/官网banner-二代AI.c9c4ac1a.png";